import generateBootFunc from '../../../../Core/generate-boot';
import Index from './Components/Index.vue';

const bootIndex = generateBootFunc(Index, 'analysis-selection-index');

export {
    bootIndex
};